<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import RobotsButton from "@/components/actions/partials/settings/RobotsButton.vue";
import XmlSitemapButton from "@/components/actions/partials/settings/XmlSitemapButton.vue";
import {computed} from "vue";

const props = defineProps({
  website: {
    required: true,
    type: Object,
  },
  pagesCount: {
    required: true,
    type: Number,
  },
});

const pagesCountText = computed(() => {
  const pageString = props.pageCount === 1 ? ' page' : ' pages';

  return props.pagesCount + pageString;
});
</script>

<template>
  <div class="tw-bg-white tw-p-8 tw-rounded-lg tw-flex tw-flex-col tw-gap-y-8 tw-w-full tw-h-[400px]">
    <p class="tw-font-bold tw-text-2.5xl">
      Crawl Overview
    </p>

    <div class="tw-rounded-lg tw-border tw-border-grey-mid tw-flex tw-flex-col tw-p-8 tw-gap-y-6 tw-h-62">
      <div class="tw-flex tw-justify-between tw-items-center">
        <p class="tw-text-lg tw-text-grey-dark">
          <span class="tw-font-bold">{{ pagesCountText }}</span>
          Found From Last Crawl
        </p>
        <DefaultButton
          size="normal"
          class="!tw-px-5 !tw-py-2 tw-h-[42px]"
          as="a"
          href="/actions/inspect"
        >
          <span>View</span>
        </DefaultButton>
      </div>

      <div class="tw-flex tw-justify-between tw-items-center">
        <p class="tw-text-lg tw-text-grey-dark">
          View XML Sitemap
        </p>
        <XmlSitemapButton />
      </div>

      <div class="tw-flex tw-justify-between tw-items-center">
        <p class="tw-text-lg tw-text-grey-dark">
          View Robots.txt
        </p>

        <RobotsButton :website-url="website.website_url" />
      </div>
    </div>
  </div>
</template>
